// Billing B3.2. Browser copy of functions/helper/fees.js, for site text
// (B9.1a). functions/test/fees-copy.test.js fails if the two differ.
// Whole numbers only: a percent is in basis points (5% = 500), money in cents.

export const FEES = {
  // yedding-brain D-0028: 5% of the venue total, rounded to the nearest $25. Minimum $25.
  managementFee: { basisPoints: 500, stepCents: 2500, minCents: 2500 },
  // D-0028: 8% of the venue total, rounded to the nearest $50. Minimum $50.
  deposit: { basisPoints: 800, stepCents: 5000, minCents: 5000 },
  // D-0050: any part of the deposit kept is split 80/20 with the host.
  depositHostBasisPoints: 8000,
  // D-0011: flat $50 after the due date.
  lateFeeCents: 5000,
  // D-0021, D-0076: only when alcohol is served. 1–150 guests $300, 151–500 guests $500.
  alcoholFee: [
    { maxGuests: 150, cents: 30000 },
    { maxGuests: 500, cents: 50000 }
  ],
  alcoholHostBasisPoints: 8000
};

const roundedShare = (cents, { basisPoints, stepCents, minCents }) => {
  if (!Number.isInteger(cents) || cents <= 0) return 0;
  const unit = 10000 * stepCents;
  const steps = Math.floor((cents * basisPoints + unit / 2) / unit);
  return Math.max(minCents, steps * stepCents);
};

/** The management fee for a venue total, in cents. */
export const managementFeeFor = (venueTotal) => roundedShare(venueTotal, FEES.managementFee);

/** The security deposit for a venue total, in cents. */
export const depositFor = (venueTotal) => roundedShare(venueTotal, FEES.deposit);

/** The alcohol fee in cents: 0 when alcohol is not served; null when the guest count has no tier. */
export const alcoholFeeFor = ({ alcohol, guestCount }) => {
  if (alcohol !== true) return 0;
  if (!Number.isInteger(guestCount) || guestCount < 1) return null;
  const tier = FEES.alcoholFee.find((t) => guestCount <= t.maxGuests);
  return tier ? tier.cents : null;
};
